// 教材章节
export const fields = [
  {
    attr: 'select',
    name: '',
    value: '',
    type: 'Select',
    props: {
      style: 'width: 100%',
      placeholder: '请选择教材版本',
      rules: {
        required: false,
        message: '请选择教材版本',
        target: 'change'
      },
      clearable: true
    },
    options: [
      // {key: '1', value: '第一章 马克思列宁主义'}
    ]
  },
  // {
  //   attr: 'tree',
  //   name: '',
  //   value: [],
  //   type: 'Tree',
  //   props: {
  //     style: 'height: calc(100vh - 190px);overflow-y: auto;',
  //     'show-checkbox': false,
  //     operation: false,
  //     placeholder: '请输入',
  //     rules: {
  //       required: false,
  //       message: '请输入',
  //       target: 'blur'
  //     },
  //     data: [
  //       // {id: '1', value: '123', children: [{value: '111'}]}
  //     ],
  //     props: {
  //       children: 'children',
  //       label: 'value'
  //     }
  //   }
  // }
]
// 知识点
export const fields2 = [
  {
    attr: 'select',
    name: '',
    value: '',
    type: 'Input',
    props: {
      style: 'width: 100%',
      placeholder: '请输入知识点',
      rules: {
        required: false,
        message: '请输入知识点',
        target: 'blur'
      },
      clearable: true
    }
  }
  // {
  //   attr: 'tree',
  //   name: '',
  //   value: [],
  //   type: 'Tree',
  //   props: {
  //     style: 'height: calc(100vh - 190px);overflow-y: auto;',
  //     'show-checkbox': false,
  //     operation: false,
  //     placeholder: '请输入',
  //     rules: {
  //       required: false,
  //       message: '请输入',
  //       target: 'blur'
  //     },
  //     data: [
  //       // {id: '1', value: '123', children: [{value: '111'}]}
  //     ],
  //     props: {
  //       children: 'children',
  //       label: 'value'
  //     }
  //   }
  // }
]
